export default {
  init : function(element) {
    $('.free-vs-premium__toggle').click(function(e){
      Kadenze.UIUtil.scrollTo($('.free-vs-premium__target'), 0.5);
      e.preventDefault();
    });
  }
};